import { buyerCheckIn, postApiCall } from 'api/apiService';
import React from 'react';
import Swal from 'sweetalert2';
import QrReader from 'react-web-qr-reader';
import { SIGNUP_URL } from 'constant/app.config';

const QRCodeScannerComponent = ({
  showScanner = false,
  setShowScanner,
  propertyId,
  setRegister,
  setCheckin,
  register,
  checkin,
  setFormValues,
  formValues,
  getListInfo,
  moxoapis,
  agencyId,
  setCheckInIndex,
  activityfun,
  setCheckInData,
  setShowScannerloader,
}) => {
  const handleScan = async (result) => {
    if (!result) return;
    if (result) {
      setShowScannerloader(true);
      const input = {
        propertyId: propertyId,
        qrCodeValue: result?.data,
      };
      try {
        const res = await buyerCheckIn(input);
        if (res?.status == 1) {
          setCheckInData(res?.buyerDetails[0]);
          const inputData = {
            userName:
              res?.buyerDetails[0]?.userName?.charAt(0)?.toUpperCase() +
              res?.buyerDetails[0]?.userName?.slice(1),
            surName:
              res?.buyerDetails[0]?.userSurName?.charAt(0)?.toUpperCase() +
              res?.buyerDetails[0]?.userSurName?.slice(1),
            email: res?.buyerDetails[0]?.userEmail,
            mobileNo: res?.buyerDetails[0]?.userPhone,
            isCheckIn: 1,
            propertyId: propertyId,
            agentId: agencyId,
            userTypeCode: 'Buyer001',
          };
          try {
            postApiCall(SIGNUP_URL, inputData).then((res) => {
              if (res?.data?.status == '1') {
                setCheckInIndex('2');
                setShowScannerloader(false);
                setShowScanner(false);
                moxoapis(res);
                if (res?.data?.heading == 'Re-inspection') {
                  Swal.fire({
                    title: res?.data?.heading ? res?.data?.heading : 'Error',
                    text: res?.data?.message,
                    showDenyButton: false,
                    showCancelButton: false,
                    icon: 'warning',
                    confirmButtonText: 'Close',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      getListInfo();
                    } else if (result.isDenied) {
                      return;
                    }
                  });
                } else {
                  getListInfo();
                  setRegister(!register);
                  setCheckin(!checkin);
                  activityfun();
                }
              } else {
                setShowScannerloader(false);
                setShowScanner(false);
                Swal.fire({
                  title: res?.data?.heading ? res?.data?.heading : 'Error',
                  text: res?.data?.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  icon:
                    res?.data?.heading == 'Buyer Verification Required'
                      ? 'warning'
                      : 'error',
                  confirmButtonText: 'Close',
                }).then((result) => {
                  if (result.isConfirmed) {
                  } else if (result.isDenied) {
                    return;
                  }
                });
              }
            });
          } catch (e) {
            setShowScannerloader(false);
            setShowScanner(false);
            Swal.fire({
              title: 'Error',
              text: 'Check-In Failed!',
              showDenyButton: false,
              showCancelButton: false,
              icon: 'error',
              confirmButtonText: 'Close',
            }).then((result) => {
              if (result.isConfirmed) {
              } else if (result.isDenied) {
                return;
              }
            });
          }
        } else {
          Swal.fire({
            title: res?.heading || 'Error',
            text: res?.message || 'An unexpected error occurred.',
            icon: 'error',
            confirmButtonText: 'Close',
          });
        }
      } catch (error) {
        setShowScannerloader(false);
        setShowScanner(false);
        Swal.fire({
          title: 'Error',
          text: 'Failed to process the QR code.',
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }
    }
  };

  const handleError = (error) => {
    console.log(error);
  };
  const delay = 100;

  const previewStyle = {
    height: 240,
    width: 320,
  };
  return (
    <div>
      {showScanner && (
        <>
          <QrReader
            delay={delay}
            style={previewStyle}
            onError={handleError}
            onScan={handleScan}
          />
        </>
      )}
    </div>
  );
};

export default QRCodeScannerComponent;
